<template>
  <div id="app">
    <div class="loader" v-if="loader">
      <div class="loader-div">
        <div class="main-loader-div">
          <img src="@/assets/images/loader.svg" class="loader-image" alt="loader" />
        </div>
        <p style="font-size:12px;text-align:center;">Please wait a moment...</p>
      </div>
    </div>
    <snackbar v-if="isSnakebar" :message="message" :backgroundColor="backgroundColor"></snackbar>
    <router-view />
  </div>
</template>

<script>
  import { eventBus } from "@/eventBus";
  import { mapActions, mapMutations, mapGetters } from "vuex";
  import { configFirebase } from "@/store/config/firebaseConfig";

  import firebase from "./components/surveyquestions/firebaseIssue";
  console.log("=======> firebase", firebase)
  export default {
    name: "app",
    data() {
      return {
        isActive: false,
        message: '',
        message: "",
        backgroundColor: "",
        leftalign: 0,
        minwidth: 0,
        loader: false,
        isSnakebar: false
      };
    },
    computed: {
      ...mapGetters(["getMode"])
    },
    methods: {
      messagesSnackbar(data) {
        this.message = data.message;
        console.log( this.message)
        if (!data.status) {
          this.backgroundColor = "#EC4C47";
        } else {
          this.backgroundColor = "#47B881";
        }
        this.isSnakebar = true;
        setTimeout(() => {
          this.isSnakebar = false;
        }, 3000);
      },
      selfcareLoader(data) {
        this.loader = data;
      },
      eventsOn() {
        eventBus.$on("nxtdigital-loader", this.selfcareLoader);
        eventBus.$on("snackBarMessage-app", data => {
          this.message = data;
          this.backgroundColor = "#EC4C47";
          this.isSnakebar = true;
          setTimeout(() => {
            this.isSnakebar = false;
            localStorage.removeItem("selfcareUser")
            this.$router.push({ name: "login" })
          }, 3000);
        });
        eventBus.$on("snackBarFullScreenMessage", data => {
          this.messagesSnackbar(data);
        });
      },
      eventsOff() {
        eventBus.$off("nxtdigital-loader", this.selfcareLoader);
        eventBus.$off("snackBarMessage-app");
        eventBus.$off("snackBarFullScreenMessage");
      }
    },
    created() {
      //this.messagesSnackbar();
      // if(this.getMode != "development") {
      //   console.log = function() {}
      // }
      this.eventsOn();
    },
    beforeDestroy() {
      this.eventsOff();
    },
    components: {
      snackbar: () =>import(/* webpackChunkName: "init-snakebar" */ "@/components/snackbar/Snackbar.vue")
    },
  };
</script>

<style scoped>
  .loader {
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
  }
  .loader-image {
    /* margin-left: 50%;
    margin-top: 45vh; */
    margin: 20% auto;
  }
  .main-loader-div {
    width: 20%;
    margin: auto;
  }
  .loader-div {
    width: 20%;
    background-color: #ffffff;
    margin: 23% auto;
    padding: 40px;
    border-radius: 13px;
  }
  @media only screen and (min-width: 320px) {
    .loader-div {
      width: 65%;
      margin: 60% auto;
    }
  }
  @media only screen and (min-width: 768px) {
    .loader-div {
      width: 40%;
      margin: 40% auto;
    }
  }
  @media only screen and (min-width: 1024px) {
    .loader-div {
      width: 30%;
      margin: 30% auto;
    }
  }
  @media only screen and (min-width: 1200px) {
    .loader-div {
      width: 20%;
      margin: 21% auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/App.vue